import {IIconFilters} from '@mintdata/mint-kit/api/assets/Icon';
import {IIllustration1Filters} from '@mintdata/mint-kit/api/assets/Illustration1';
import {UploadedImage} from '@mintdata/mint-kit/api/assets/UploadedImage';

export class GraphicRef
{
    constructor(public name:string,
                public type:GraphicType)
    {
    }

    public toString():string
    {
        return `${this.type.toLowerCase()}:${this.name}`;
    }

    public static fromString(str:string, getUploadedImageByUrl:(url:string) => UploadedImage):GraphicRef
    {
        const illustration1Prefix:string = GraphicRef._getPrefix(GraphicType.Illustration1);
        const illustration2Prefix:string = GraphicRef._getPrefix(GraphicType.Illustration2);
        const photoPrefix:string = GraphicRef._getPrefix(GraphicType.Photo);
        const uploadedImagePrefix:string = GraphicRef._getPrefix(GraphicType.UploadedImage);

        if( str.startsWith(illustration1Prefix) )
            return new GraphicRef(str.replace(illustration1Prefix, ''), GraphicType.Illustration1);

        if( str.startsWith(illustration2Prefix) )
            return new GraphicRef(str.replace(illustration2Prefix, ''), GraphicType.Illustration2);

        if( str.startsWith(photoPrefix) )
            return new GraphicRef(str.replace(photoPrefix, ''), GraphicType.Photo);

        if( str.startsWith(uploadedImagePrefix) )
            return new GraphicRef(str.replace(uploadedImagePrefix, ''), GraphicType.UploadedImage);

        const uploadedImage:UploadedImage = getUploadedImageByUrl(str);

        if( uploadedImage )
            return new GraphicRef(uploadedImage.name, GraphicType.UploadedImage);

        return new GraphicRef(null, null);
    }

    private static _getPrefix(type:GraphicType):string
    {
        return `${type.toLowerCase()}:`;
    }
}

export interface IGraphic
{
    getType():GraphicType;

    getRef():GraphicRef;
}

export enum GraphicType
{
    Icon = 'Icon',
    Illustration1 = 'Drawings1',
    Illustration2 = 'Drawings2',
    Photo = 'Photo',
    UploadedImage = 'UploadedImage',
}

export enum GraphicSource
{
    Favorite = 'Favorite',
    Recent = 'Recent',
}

export interface IGraphicFilters
{
    source:GraphicSource;
    types:GraphicType[];
    illustration1Filters?:IIllustration1Filters;
    iconFilters?:IIconFilters;
}
